import React, { useState, useContext } from "react";
import api from "../../utils/axios";
import { Box, Button, Heading, Input, Stack, Text } from "@chakra-ui/react";
import { UserContext } from "../../context/UserContext";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState(false);
  const [emailSendSuccess, setEmailSendSuccess] = useState(false);
  const { language } = useContext(UserContext);

  async function sendEmail(e) {
    e.preventDefault();

    setEmailSendSuccess(false);
    setErrorMessage("");

    if (email === "") {
      setErrorMessage((language === "en" ? "The email address cannot be empty." : 
                        "電郵地址不能空白"));
      return;
    }

    try {
      const response = await api.post(`/api/auth/send-reset-email/${email}`);
      if (response.status === 200) {
        setEmailSendSuccess(true);
      }
    } catch (err) {
      setErrorMessage(
        err.response.data.message ||
          "An unexpected error occurred. Please try again later."
      );
    }
  }

  return (
    <>
      <Heading textAlign="center" margin="20px">
        {language === "en" ? "Forgot Password" : "忘了密码"}
      </Heading>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        margin={10}
      >
        <form onSubmit={sendEmail}>
          <Stack direction="column" spacing={5}>
            <Input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={language === "en" ? "Email Address" : 
                            "電郵地址"}
            />
            <Button size="md" variant="outline" colorScheme="blue" leftIcon type="submit">
              {language === "en"
                ? "Send Password Reset Email"
                : "提交重設密码電邮"}
            </Button>
            <Text fontSize="xs">
              {language === "en"
                ? `Note: You will receive a reset password link and instruction in the email entered above \nafter clicked on "Send Password Reset Email" button above`
                : `請注意: 点擊了"提交重設密碼電郵"的按鈕後,您會在以上輸入的電郵地址的收件夾裏,收到重設密碼的鏈接和用法的郵件.`}
            </Text>
            {errorMessage.length > 0 && (
              <div style={{color: 'red'}}>
                <p>{errorMessage}</p>
              </div>
            )}
            {emailSendSuccess && (
              <div>
                <p>
                  {language === "en" ? "Password Reset Email Successfully Sent!" :
                        "重新設定密码的電子邮件成功送出!"}
                </p>
              </div>
            )}
          </Stack>
        </form>
      </Box>
    </>
  );
}

export default ForgotPassword;
